import { SignupFormsReplacedByPopupsModal } from "@redotech/redo-merchant-app-common/feature-onboarding/signup-forms-replaced-by-popups-modal";
import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo, useState } from "react";
import popupsImageUrl from "../assets/spotlights-renamed-popup.png?url";
import { OnboardingProps } from "../common";

export const SignupFormsReplacedByPopupsOnboarding = memo(
  function SignupFormsReplacedByPopupsOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const [modalOpen, setModalOpen] = useState(false);
    const openModal = () => {
      setModalOpen(true);
    };

    return (
      <>
        {modalOpen ? (
          <SignupFormsReplacedByPopupsModal
            handleComplete={handleComplete}
            handleDismiss={handleDismiss}
          />
        ) : (
          <RedoFeatureNotificationCard
            actionText="Learn more"
            description={
              "Spotlights are now out of beta and have been renamed to Popups! " +
              "Signup forms will be phased out in favor of Popups in the next 2-3 weeks."
            }
            image={popupsImageUrl}
            onAction={openModal}
            onDismiss={handleDismiss}
            title="Spotlights out of beta"
          />
        )}
      </>
    );
  },
);
